// extracted by mini-css-extract-plugin
module.exports = {"linksContainer":"_7e9bcdc","link":"_c9e713f","iconsContainer":"_a2ebb22","plus18":"_24acc15","dkLogo":"_a9c69b4"};